import { atom } from "jotai";
import { State } from "./State";
import { fetchBase, postBase, putBase } from "./BaseApi";

export type PostUsersSubmissionParam = {
  simulationType: string;
};

export type PostUsersSubmissionResponse = {
  submissionId: number;
};

export type PutUsersSubmissionParam = {
  userId: string;
};

const unregisteredUri = "api/unregistered-users/submission";
const uri = "api/users/submission";

export const postUsersSubmissionAtom = atom<State<PostUsersSubmissionResponse> | null>(null);
export const postUnregisteredUsersSubmission = () => {
  return postBase<PostUsersSubmissionResponse, PostUsersSubmissionParam>(
    unregisteredUri,
    postUsersSubmissionAtom
  );
};

export const putUsersSubmissionAtom = atom<State<null> | null>(null);
export const putUnregisteredUsersSubmission = () => {
  return putBase<null, PutUsersSubmissionParam>(
    unregisteredUri,
    putUsersSubmissionAtom
  );
};
export const postRegisteredUsersSubmission = () => {
  return postBase<null, PostUsersSubmissionParam>(
    uri,
    putUsersSubmissionAtom
  );
};